import { render, staticRenderFns } from "./suspensionModel.vue?vue&type=template&id=c8e31172"
import script from "./suspensionModel.vue?vue&type=script&lang=js"
export * from "./suspensionModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8e31172')) {
      api.createRecord('c8e31172', component.options)
    } else {
      api.reload('c8e31172', component.options)
    }
    module.hot.accept("./suspensionModel.vue?vue&type=template&id=c8e31172", function () {
      api.rerender('c8e31172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contract/contractManage/suspensionModel.vue"
export default component.exports